export default __webpack_public_path__ + "static/media/19.223e3e16.jpg";